export default {
  projectDesc: 'A simple region selector for <strong>Vue2</strong>, provide Chinese administrative division data.',
  demo: {
    modes: {
      formElement: 'Regular form select element mode',
      plainText: 'Plain text mode',
      selector: 'Selector mode'
    },
    desc: 'Base mode and ui selector mode',
    province: 'Province',
    city: 'City',
    area: 'Area/County',
    town: 'Town/Street',
    selected: 'Region selected result',
    init: 'Init region selected',
    dropdown: 'Region dropdown selector',
    customCaller: 'Region ui selector with customize caller',
    disabled: 'Disabled region select element',
    text: 'The initialized region info show by Plain Text',
    textSeparator: 'Display text content with separators between regions',
    columns: {
      title: 'Multi-column selector',
      base: 'Multi-column core module'
    },
    group: {
      title: 'Multi-group selector',
      base: 'Multi-group core module'
    },
    cityPicker: 'city picker'
  },
  option: {
    blank: 'build default "please select" item, the value was blank, only work on "RegionSelects" component',
    city: 'enable city level',
    area: 'enable area/county level',
    town: 'enable town/street',
    search: 'enable search bar, only work on "RegionGroup" component',
    selected: 'initialize region selected item',
    cityPickerSelected: 'city picker initialize selected item data format:',
    disabled: 'disabled region select element, only work on regular select element mode',
    language: 'the language used in the plugin',
    separator: 'display text content with separators between regions, work on "RegionText" component',
    overflow: 'when there are many cities selected, other cities are only displayed in quantity, work on "RegionCityPicker" component'
  },
  event: {
    values: 'Responds to the selected administrative division complete data model'
  }
}
